import { api } from '@/lib/api'
import { API_PATHS } from '@/constants/api-paths'
import type { ApiResponse, EventTag } from '@/types'

const EVENT_TAG_PATHS = API_PATHS.jobs.eventTags

export type EventTagCreatePayload = {
  title: string
  code?: string
}

export type EventTagUpdatePayload = {
  title?: string
  code?: string
}

export const eventTagsApi = {
  list: async (params?: { include_inactive?: boolean }): Promise<EventTag[]> => {
    const queryParams: Record<string, unknown> = { kind: 'event' }
    if (params?.include_inactive) {
      queryParams.include_inactive = true
    }
    const response = await api.get<ApiResponse<EventTag[]>>(EVENT_TAG_PATHS.list, { params: queryParams })
    return response.data.data ?? []
  },

  get: async (id: string | number): Promise<EventTag> => {
    const response = await api.get<ApiResponse<EventTag>>(EVENT_TAG_PATHS.detail(id))
    return response.data.data
  },

  create: async (payload: EventTagCreatePayload): Promise<EventTag> => {
    const response = await api.post<ApiResponse<EventTag>>(EVENT_TAG_PATHS.create, payload)
    return response.data.data
  },

  update: async (id: string | number, payload: EventTagUpdatePayload): Promise<EventTag> => {
    const response = await api.post<ApiResponse<EventTag>>(EVENT_TAG_PATHS.update(id), payload)
    return response.data.data
  },

  deactivate: async (id: string | number): Promise<EventTag> => {
    const response = await api.post<ApiResponse<EventTag>>(EVENT_TAG_PATHS.deactivate(id))
    return response.data.data
  },

  activate: async (id: string | number): Promise<EventTag> => {
    const response = await api.post<ApiResponse<EventTag>>(EVENT_TAG_PATHS.activate(id))
    return response.data.data
  },
}

export default eventTagsApi
